const React = require("react");
const {default: FormControl} = require("@material-ui/core/FormControl");
const {default: InputLabel} = require("@material-ui/core/InputLabel");
const {default: Select} = require("@material-ui/core/Select");
const Arrow = require("./svg/ArrowBase");

const ErrorDisplay = require('../ErrorDisplay');
const selectCtor = require("../../utils/selectCtor");

const SelectWrapper = ({children, className, showError, disabled}) => (
  <div className={`
      w rlv
      (w|pt10|pb18)>.MuiFormControl-root
      (dB|rlv|pb14|c0-i|f12|fw4|ff$3|x)>.MuiFormLabel-root
      (mt0|bgF|b1|bs|bc0|r9)>.MuiInputBase-root
      (bcF00).error>.MuiInputBase-root
      (pt12|ph25|pb15|f12|fw7|ff$3)>.MuiSelect-root
      (bgTransparent-i)>.Mui-focused
      (dN)>.MuiInput-underline:before
      (dN)>.MuiInput-underline:after
      (bg0.25|o50).disabled>.MuiInputBase-root
    `
    + (disabled ? ' disabled' : '')
    + (showError ? ' error' : '')
    + (className ? ` ${className}` : '')
  }>
    {children}
  </div>
);

const Label = ({id, label, isRequired, disableLabel}) => (
    !disableLabel && label
      ? (
        <InputLabel
          htmlFor={id}
        >
          {label}  {isRequired ? '*' : ''}
        </InputLabel>
      ) : null
);

const SelectDisplay = ({value, name, itemsDisplay, onChange, disabled}) => (
  <Select
    value={value || ''}
    onChange={(e) => onChange(name, e.target.value)}
    IconComponent={Arrow}
    disabled={disabled}
  >
    {itemsDisplay}
  </Select>
);

module.exports = selectCtor(({
  className,
  labelProps,
  selectProps,
  errorProps
}) => (
  <SelectWrapper
    className={className}
    showError={errorProps.showError}
    disabled={selectProps.disabled}
  >
    <FormControl variant="standard">
      <Label {...labelProps} />
      <SelectDisplay {...selectProps} />
    </FormControl>
    <ErrorDisplay {...errorProps} />
  </SelectWrapper>
));
